<style scoped lang="less">
  .produce-tag{
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .icon{
    cursor: pointer;
  }
</style>
<template>
  <div>
    <div>
      <el-tag class="produce-tag" v-for="(item, index) in tagNames"
              :key="item + index"
              v-if="showMore?showMore:index<8"
              type="success">{{tagNameWithLang(item)}}
      </el-tag>
    </div>
    <div>
      <div class="more" v-if="tagNames.length>=8" @click="openMore">
        <div class="icon ml5" v-if="!showMore">
          <i class="el-icon-arrow-up"></i>
        </div>
        <div v-else class="icon ml5">
          <i class="el-icon-arrow-down"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {tagNameWithLang} from "@common/utils";

  export default {
    props: ['tagNames'],
    data() {
      return {showMore: false}
    },
    methods: {
      tagNameWithLang(tagName) {
        return tagNameWithLang(tagName)
      },
      openMore() {
        this.showMore = !this.showMore
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/wenxing/components/tagList.vue